// GlowSkinHouse — seznam želja (B1, ADR-0023): srce v trgovini govori s Sphere.
//
// Kaj ta datoteka JE: tanka plast NAD obstoječim lokalnim seznamom v
// `gsh-theme.js`. Lokalni seznam (`localStorage.gsh_wishlist`, ključi so
// HANDLI) ostane edini vir za izris src in za predal — zato srce dela tudi,
// kadar je strežnik izklopljen, nedosegljiv ali kupec ni prijavljen.
//
// Kaj ta datoteka NI: ne izrisuje ničesar in ne posluša klikov. Posluša samo
// dogodek `gsh:wishlist:change`, ki ga sproži `gsh-theme.js`.
//
// Pot je Shopifyjev App Proxy (`/apps/gsh/*`): zahtevek gre z domene trgovine,
// Shopify ga podpiše in doda `logged_in_customer_id`. Zato tu ni ne CORS-a ne
// tujih piškotkov in ne pošiljamo nobenega žetona.
//
// PAST, zaradi katere je vsak odgovor preverjen dvakrat: dokler na produkciji
// poti `/apps/gsh/wishlist` ni, Shopify zahtevek vseeno preusmeri in Worker
// vrne HTML portala s statusom 200. `JSON.parse` bi vrgel napako in srce bi se
// pokvarilo. Zato: kar ni `application/json` z znano obliko, šteje za
// „funkcija ni na voljo" in tiho pademo na lokalni seznam.
(function () {
  'use strict';

  var C = window.gshWishlistConfig || {};
  var POT = C.proxy || '/apps/gsh/wishlist';
  var PRIJAVLJEN = C.loggedIn === true;
  var KUPEC = String(C.customerId || '');

  var KLJUC_MAPA = 'gsh_wishlist_map';        // handle -> številčni ID izdelka
  var KLJUC_STANJE = 'gsh_wishlist_state';    // stanje strežnika za to sejo
  var KLJUC_ZDRUZENO = 'gsh_wishlist_merged'; // kupec, za katerega je združitev uspela

  // Ali strežnik sploh govori z nami. `null` = še ne vemo.
  var omogoceno = null;
  var katalogPoskusen = false;

  /* ---------- shramba (vsak dostop sme odpovedati: zaseben način) ---------- */

  function beri(kljuc, priv) {
    try { return JSON.parse(localStorage.getItem(kljuc)) || priv; } catch (e) { return priv; }
  }
  function pisi(kljuc, vrednost) {
    try { localStorage.setItem(kljuc, JSON.stringify(vrednost)); } catch (e) {}
  }
  function beriSejo(kljuc) {
    try { return JSON.parse(sessionStorage.getItem(kljuc)); } catch (e) { return null; }
  }
  function pisiSejo(kljuc, vrednost) {
    try { sessionStorage.setItem(kljuc, JSON.stringify(vrednost)); } catch (e) {}
  }

  /* ---------- mapa handle <-> ID ---------- */
  //
  // Strežnik hrani samo številčne ID-je (pravilo 18), predal pa za izpis
  // potrebuje handle. Mapo gradimo sproti iz vsake strani, ki jo kupec vidi —
  // izdelek, ki mu je dal srce, je s tem že v mapi.

  var mapa = beri(KLJUC_MAPA, {});

  function zapisiPar(handle, id) {
    if (!handle || !id) return;
    id = String(id);
    if (!/^[0-9]+$/.test(id) || mapa[handle] === id) return;
    mapa[handle] = id;
    pisi(KLJUC_MAPA, mapa);
  }

  function handleZaId(id) {
    id = String(id);
    for (var h in mapa) { if (mapa[h] === id) return h; }
    return null;
  }

  function poberiIzStrani() {
    var gumbi = document.querySelectorAll('[data-gsh-wishlist-toggle][data-gsh-wishlist-id]');
    for (var i = 0; i < gumbi.length; i++) {
      zapisiPar(gumbi[i].getAttribute('data-gsh-wishlist-toggle'), gumbi[i].getAttribute('data-gsh-wishlist-id'));
    }
  }

  /** ID izdelka za handle; če ga v mapi ni, ga poišče pri Shopifyju (en izdelek). */
  function idZaHandle(handle) {
    if (!handle || handle.indexOf('article-') === 0) return Promise.resolve(null);
    if (mapa[handle]) return Promise.resolve(mapa[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.id) return null;
        zapisiPar(handle, p.id);
        return String(p.id);
      })
      .catch(function () { return null; });
  }

  /**
   * Handli za ID-je, ki jih v mapi ni — to so izdelki, shranjeni na DRUGI
   * napravi. Celoten katalog preberemo samo takrat in samo enkrat na sejo;
   * datoteka je velika in je ne smemo vleči ob vsakem obisku.
   */
  function dopolniMapo(neznani) {
    if (!neznani.length || katalogPoskusen) return Promise.resolve();
    katalogPoskusen = true;
    return fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (b) {
        if (!b || !b.products) return;
        for (var i = 0; i < b.products.length; i++) zapisiPar(b.products[i].handle, b.products[i].id);
      })
      .catch(function () {});
  }

  /* ---------- pogovor s strežnikom ---------- */

  /**
   * Odgovor sprejmemo samo, če je JSON in ima obliko, ki jo pričakujemo.
   * Vse drugo (HTML portala, 404, 405, prazno telo) ni napaka kupca — pomeni
   * „poti še ni" in tiho ugasne sinhronizacijo za to sejo.
   */
  function preberi(odgovor) {
    var vrsta = odgovor.headers.get('content-type') || '';
    if (vrsta.indexOf('application/json') < 0) return Promise.reject({ tiho: true });
    return odgovor.json().then(function (telo) {
      if (!odgovor.ok) {
        return Promise.reject({
          status: odgovor.status,
          koda: telo && telo.error ? telo.error.code : '',
          sporocilo: telo && telo.error ? telo.error.message : ''
        });
      }
      if (!telo || !telo.data || typeof telo.data.enabled !== 'boolean') return Promise.reject({ tiho: true });
      return telo.data;
    }, function () { return Promise.reject({ tiho: true }); });
  }

  function klic(pot, moznosti) {
    moznosti = moznosti || {};
    moznosti.credentials = 'same-origin';
    moznosti.headers = moznosti.headers || {};
    moznosti.headers['accept'] = 'application/json';
    return fetch(pot, moznosti).then(preberi);
  }

  /** Napaka, po kateri nima smisla več poskušati do konca seje. */
  function ugasni() {
    omogoceno = false;
    pisiSejo(KLJUC_STANJE, { enabled: false });
  }

  function obvesti(sporocilo) {
    if (!sporocilo) return;
    try { document.dispatchEvent(new CustomEvent('gsh:toast', { detail: { message: sporocilo } })); } catch (e) {}
  }

  /* ---------- uskladitev lokalnega seznama s strežnikom ---------- */
  //
  // Strežnik je resnica za IZDELKE. Shranjeni članki (`article-<id>`) so samo
  // lokalni in jih pri tem nikoli ne izgubimo — zato uskladitev seznama ne
  // prepiše, ampak ga sestavi znova iz obeh delov.

  function uskladi(productIds) {
    var neznani = [];
    var handli = [];
    for (var i = 0; i < productIds.length; i++) {
      var h = handleZaId(productIds[i]);
      if (h) { if (handli.indexOf(h) < 0) handli.push(h); }
      else neznani.push(String(productIds[i]));
    }

    var koncaj = function () {
      for (var j = 0; j < neznani.length; j++) {
        var h2 = handleZaId(neznani[j]);
        if (h2 && handli.indexOf(h2) < 0) handli.push(h2);
      }
      var lokalni = window.gshWishlist ? window.gshWishlist.get() : [];
      var clanki = lokalni.filter(function (x) { return typeof x === 'string' && x.indexOf('article-') === 0; });
      if (window.gshWishlist) window.gshWishlist.set(clanki.concat(handli));
    };

    if (!neznani.length) { koncaj(); return Promise.resolve(); }
    return dopolniMapo(neznani).then(koncaj);
  }

  /** Kar je kupec shranil kot neprijavljen, gre ob prvi prijavi na račun. */
  function zdruzi() {
    var lokalni = window.gshWishlist ? window.gshWishlist.get() : [];
    var handli = lokalni.filter(function (x) { return typeof x === 'string' && x.indexOf('article-') !== 0; });
    return Promise.all(handli.map(idZaHandle)).then(function (idji) {
      var cisti = idji.filter(Boolean);
      return klic(POT + '/merge', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ productIds: cisti })
      }).then(function (stanje) {
        // Lokalnega seznama NE praznimo — uskladitev ga postavi na stanje
        // strežnika, članki ostanejo. Zastavico postavimo šele ob uspehu.
        if (stanje.enabled === true) pisi(KLJUC_ZDRUZENO, KUPEC);
        return stanje;
      });
    });
  }

  /* ---------- zagon ---------- */

  function zacni() {
    poberiIzStrani();

    var shranjeno = beriSejo(KLJUC_STANJE);
    if (shranjeno && shranjeno.enabled === false) { omogoceno = false; return; }

    var jeZdruzeno = beri(KLJUC_ZDRUZENO, '') === KUPEC;
    var zacetni = (PRIJAVLJEN && KUPEC && !jeZdruzeno)
      ? zdruzi()
      : klic(POT, { method: 'GET' });

    zacetni.then(function (stanje) {
      omogoceno = stanje.enabled === true;
      pisiSejo(KLJUC_STANJE, { enabled: omogoceno });
      if (omogoceno && PRIJAVLJEN) return uskladi(stanje.productIds || []);
    }).catch(function () {
      // Neprijavljenemu 401 ni napaka in izklop ni napaka: srce dela naprej,
      // seznam je v brskalniku. Tiho je tu prava odločitev, ne lenoba.
      ugasni();
    });
  }

  /* ---------- klik na srce ---------- */

  document.addEventListener('gsh:wishlist:change', function (e) {
    var d = (e && e.detail) || {};
    var handle = d.handle;
    if (!handle || handle.indexOf('article-') === 0) return;  // članki so samo lokalni
    if (omogoceno === false || !PRIJAVLJEN) return;

    idZaHandle(handle).then(function (id) {
      if (!id) return;
      var zahtevek = d.added
        ? klic(POT, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ productId: id }) })
        : klic(POT + '/' + id, { method: 'DELETE' });

      return zahtevek.then(function (stanje) {
        omogoceno = stanje.enabled === true;
        pisiSejo(KLJUC_STANJE, { enabled: omogoceno });
      }).catch(function (napaka) {
        napaka = napaka || {};
        // Seznam je poln: to je edina napaka, ki jo kupec MORA videti, ker je
        // njegovo dejanje ostalo neizvedeno in bi sicer mislil, da ni.
        if (napaka.koda === 'WISHLIST_FULL') {
          obvesti(napaka.sporocilo);
          if (window.gshWishlist && d.added) window.gshWishlist.remove(handle);
          return;
        }
        // Vse drugo (401 potekla seja, 503 izklop, pokvarjen odgovor) tiho:
        // izdelek ostane shranjen v brskalniku in srce je še vedno rdeče.
        ugasni();
      });
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zacni);
  else zacni();
})();
